import React from 'react';
import { CustomCellRendererProps } from 'ag-grid-react';
import { ServerDashboardJob } from '../../dashboardType';
import { formatUserEmail } from '../../utils/formatUserEmail';

const UserCell = (properties: CustomCellRendererProps<ServerDashboardJob>) => {
  const userEmail = properties.data?.user?.email;

  if (!userEmail) {
    return null;
  }

  const formattedName = formatUserEmail(userEmail);

  return <span>{formattedName}</span>;
};

export default UserCell;
